import { useEffect, useRef } from 'react';

const useEffectOnce = (callback: () => void, when: boolean = true) => {
  const hasRun = useRef(false);

  useEffect(() => {
    if (when && !hasRun.current) {
      hasRun.current = true;
      callback();
    }
  }, [when]);
};

export default useEffectOnce;
